import axios from "axios"
import Constants from "../globals/Constants";

export default axios.create({
  baseURL: Constants.BASE_API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})
